import ResultItem from "cartovistaExtend/panels/Results/ResultItem";

export default class  ServiceAreasResultItem extends ResultItem {
        constructor(resultList, features, name) {
          super(resultList, features, name);
          this._styleIconCanvas = null;
        };
  }